import React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { parseListDate } from "helpers/parseListDate";
import { generateInitialValues } from "../../../Task";
import { HeaderTaskMilestoneProps } from "../GatewaySummary.types";
import { HeaderTaskDateFields } from "./HeaderTaskDateFields";

/**
 * HeaderTaskMilestone component renders the header task (milestone) details
 * Includes date fields for Planned, Forecast, and Actual dates
 * Wrapped in Formik for form handling
 */
const HeaderTaskMilestone: React.FC<HeaderTaskMilestoneProps> = ({
  task,
  bEditable,
  projectID,
  gatewaysID,
  gatewayTemplateID,
  gatewayIndex,
  taskIndex,
  gatewayData,
  setGatewayData,
  backgroundReloadGatewayDataToggle,
  setBackgroundReloadGatewayDataToggle,
}) => {
  const validationSchema = Yup.object().shape({
    customFields: Yup.array().of(Yup.object().nullable()),
  });

  return (
    <Formik
      initialValues={generateInitialValues(
        projectID as number,
        task,
        gatewaysID as string | number,
        gatewayTemplateID as string | number
      )}
      onSubmit={() => {}}
      validationSchema={validationSchema}
    >
      {(formik) => {
        // Format completed date with time if available
        let parsedCompletedDate = `${parseListDate(task.completedDate, true) ?? ""}`;
        const splitDate = parsedCompletedDate.split(":");

        if (splitDate.length === 4) {
          parsedCompletedDate = `${splitDate[0]}    ${splitDate[1]}:${splitDate[2]}:${splitDate[3]}`;
        }

        return (
          <Form className="HeaderMilestone">
            <HeaderTaskDateFields
              task={task}
              bEditable={bEditable}
              projectID={projectID}
              gatewaysID={gatewaysID}
              gatewayTemplateID={gatewayTemplateID}
              gatewayIndex={gatewayIndex}
              taskIndex={taskIndex}
              gatewayData={gatewayData}
              setGatewayData={setGatewayData}
              backgroundReloadGatewayDataToggle={backgroundReloadGatewayDataToggle}
              setBackgroundReloadGatewayDataToggle={setBackgroundReloadGatewayDataToggle}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export { HeaderTaskMilestone };
